<template>
  <div
    class="qna-session animate__slideInUp animate__animated animate__faster vertical layout"
    id="qna-session-box"
  >
    <div class="text-right close-icon" @click="closeQna()">
      {{ $t("closeAvatar") }}
      <i class="fas fa-times" />
    </div>
    <div class="qna-submit-box">
      <div class="text-box" :class="{error: questionTitle.length > 200}">
        <textarea
          rows="3"
          :placeholder="$t('qnaQuestionPlaceholder')"
          v-model="questionTitle"
          :maxlength="maxQuestionTitleLength"
          @input="onInput"
        />
        <div class="count-char">
          {{ maxQuestionTitleLength - questionTitle.length }}
        </div>
      </div>
      <div class="horizontal layout center">
        <div class="avatar">
          <div class="default-ava" v-if="!checkAudienceName()">
            <i class="fas fa-user" />
          </div>
          <div
            class="color-ava"
            v-if="checkAudienceName()"
            :style="{ 'background-color': audienceColor}"
          >
            {{ $store.state.questionerName | textAvatar }}
          </div>
        </div>
        <input
          type="text"
          :placeholder="_getPlaceHolder()"
          class="flex input-name"
          v-model="$store.state.questionerName"
          @input="saveAudienceName()"
          :class="{error: (20 - $store.state.questionerName.length) < 0}"
          maxlength="20"
        >
        <button
          class="button-submit horizontal layout center center-justified"
          :disabled="checkDisableSubmit()"
          @click="submitQuestion()"
        >
          {{ $t("submit") }}
          <i class="fas fa-check" v-if="!submiting" />
          <span class="loading-spinner" v-else />
        </button>
      </div>
      <div class="text-error text-danger" v-if="textError">
        {{ textError }}
      </div>
    </div>
    <div class="flex list-questions vertical layout">
      <div
        class="tab-list-question"
        :class="{'white-text': $store.state.slide.textColour == '#ffffff'}"
      >
        <ul>
          <li
            :class="{active: $store.state.tabQnaQuestion == 1}"
            @click="changeTabQuestion(1)"
          >
            {{ $t("topQuestionsAudience") }}
          </li>
          <li
            :class="{active: $store.state.tabQnaQuestion == 2}"
            @click="changeTabQuestion(2)"
          >
            {{ $t("newQuestionsAudience") }}
          </li>
          <li
            :class="{active: $store.state.tabQnaQuestion == 3}"
            @click="changeTabQuestion(3)"
          >
            {{ $t("answeredQuestions") }}
          </li>
          <li
            :class="{active: $store.state.tabQnaQuestion == 4}"
            @click="changeTabQuestion(4)"
          >
            {{ $t("myQuestions") }}
          </li>
        </ul>
        <span class="question-count" :class="{'dark': $store.state.slide.textColour === '#ffffff'}">
          <span
            class="mr-1 question-count-icon"
          >
            <i class="fas fa-question-circle" />
          </span>
          <span class="question-count-number">
            <AhaFormatter :value="$store.state.questionCount" type="KMB" />
          </span>
        </span>
      </div>
      <div
        class="flex list-item-question"
        :class="{'no-allow-vote-count': !$store.state.presentation.qnaAudienceShowAll}"
        id="list-qna-question"
      >
        <div
          v-for="(item, index) in $store.state.questions"
          :key="index"
          class="item-question"
          v-show="checkShowQuestion(item)"
        >
          <div>
            <div class="top-item-question horizontal layout center">
              <div class="avatar">
                <div class="default-ava" v-if="!item.audienceName">
                  <i class="fas fa-user" />
                </div>
                <div
                  class="color-ava"
                  v-if="item.audienceName"
                  :style="{ 'background-color': item.audienceColor}"
                >
                  {{ item.audienceName | textAvatar }}
                </div>
              </div>
              <div class="name">
                <div class="name-audience">
                  <span v-if="item.audienceName">
                    <profanity-filter :text="item.audienceName" />
                  </span>
                  <span v-if="!item.audienceName">Anonymous</span>
                </div>
                <div class="time-post">
                  {{ item.createdAt | dateTimeAgo }}
                </div>
              </div>
              <i class="fas fa-thumbtack icon-pinned" v-if="item.pinned" />
              <AhaIcon
                :name="getQuestionStatusIcon(item)"
                class="question-status"
                viewBox="0 0 24 24"
                width="20"
                height="20"
                :class="{'text-white': textColour === '#ffffff'}"
                v-if="isTabMyQuestionsAndModerationMode && !item.answered"
              />
              <AhaIcon
                name="answered"
                viewBox="0 0 24 24"
                class="question-status question-status__answered-icon"
                :class="{'text-white': textColour === '#ffffff'}"
                v-if="isTabMyQuestionsAndModerationMode && item.answered"
              />
              <div
                class="action-vote horizontal layout center center-justified"
                @click="voteQuestion(item)"
                :class="{'dark': textColour === '#ffffff', 'active': item.voted}"
                v-if="$store.state.presentation.qnaAudienceShowAll"
              >
                <span class="upvote-wrapper">
                  <i class="mr-1 fas fa-thumbs-up upvote-icon" v-if="!item.isLoading" />
                  <span
                    class="loading-spinner"
                    :class="{'black': textColour == '#313131'}"
                    v-else
                  />
                </span>
                <span class="upvote-count">{{ item.voteCount }}</span>
              </div>
            </div>
            <div class="content-question">
              <span>{{ item.title | profanity }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ProfanityFilter from '@/components/utils/ProfanityFilter.vue'
import Config from '../config'
import Utils from '../util'
import storage from '../services/storage'
import constants from '../constant'
import UserIsTypingMixin from '../mixins/UserIsTypingMixin'
import socket from '../socket'
import QuestionApi from '../api/question'

const tabQna = constants.tabQnaQuestion

export default {
  components: {
    ProfanityFilter,
  },
  mixins: [UserIsTypingMixin],
  data() {
    return {
      submiting: false,
      questionTitle: '',
      maxQuestionTitleLength: 200,
      audienceColor: '',
      textError: '',
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
      tabQnaQuestion: (state) => state.tabQnaQuestion,
      textColour: (state) => state.slide.textColour,
    }),
    isTabMyQuestionsAndModerationMode() {
      return this.tabQnaQuestion === 4 && this.presentation.isModerationMode
    },
  },
  mounted() {
    this._getPlaceHolder()
    if (document.getElementById('qna-session-box')) {
      document.getElementById(
        'qna-session-box',
      ).style.backgroundColor = this.$store.state.slide.baseColour
      document.getElementById(
        'qna-session-box',
      ).style.color = this.$store.state.slide.textColour
    } else {
      setTimeout(() => {
        document.getElementById(
          'qna-session-box',
        ).style.backgroundColor = this.$store.state.slide.baseColour
        document.getElementById(
          'qna-session-box',
        ).style.color = this.$store.state.slide.textColour
      }, 500)
    }

    if (!this.audienceId) {
      this.audienceColor = '#313131'
    } else {
      this.audienceColor = Utils.getColorByStr(this.audienceId)
    }

    const presentationId = this.$store.state.presentation.id
    this.$store.state.questionerName = storage.getValueByPresentation(
      presentationId,
      'questionerName',
      '',
    )

    if (this.$store.state.audienceName && !this.$store.state.questionerName) {
      this.$store.state.questionerName = this.$store.state.audienceName
      this.saveAudienceName()
    }
  },
  methods: {
    closeQna() {
      this.$store.state.showQaSession = false
      Utils.gaTrackEvent(
        'Question And Answer',
        'Audience',
        'Close Ask a question popup',
      )
    },
    checkAudienceName() {
      const name = this.$store.state.questionerName
      if (!name.trim()) {
        return false
      }
      return true
    },

    saveAudienceName() {
      this.textError = ''
      const {
        questionerName,
        presentation: { id: presentationId },
      } = this.$store.state
      storage.setValueByPresentation(
        presentationId,
        'questionerName',
        questionerName,
      )
      Utils.gaTrackEvent('Question And Answer', 'Audience', 'Edited name')
    },

    voteQuestion(item) {
      this._updateAudienceIDToStorage()
      this._setVoteQuestionLoading(item)
      this._handleVoteQuestion(item)
    },

    _updateAudienceIDToStorage() {
      storage.updateValueByPresentation(
        this.presentation.id,
        'audienceId',
        this.audienceId,
      )
    },

    _setVoteQuestionLoading(item) {
      const index = this.$store.state.questions.findIndex((question) => {
        return question.id === item.id
      })
      if (this.$store.state.questions[index].isLoading) return
      this.$store.state.questions[index].isLoading = true
      this.$store.state.questions.push()
    },

    async _handleVoteQuestion(item) {
      try {
        const res = await QuestionApi.voteQuestion({
          id: item.id,
          presentationId: this.presentation.id,
          audience: this.audienceId,
          accessCode: this.presentation.uniqueAccessCode,
          socketId: socket.getSocketId(),
        })
        if (res.voted) {
          Utils.gaTrackEvent(
            'Question And Answer',
            'Audience',
            'Upvoted question',
          )
        } else {
          Utils.gaTrackEvent(
            'Question And Answer',
            'Audience',
            'Un-upvoted question',
          )
        }
      } catch (error) {
        this._setVoteQuestionLoading(item)
      }
    },

    checkShowQuestion(item) {
      // Moderation ON -> tab TOP, NEW, ANSWERED only show approved questions
      if (
        this.presentation.isModerationMode &&
        item.status !== 'approved' &&
        this.tabQnaQuestion !== tabQna.MY_QUESTIONS
      ) { return false }

      if (
        this.tabQnaQuestion === tabQna.MY_QUESTIONS ||
        !this.presentation.qnaAudienceShowAll
      ) {
        if (item.audience !== this.$store.state.audienceId) return false
      }
      if (
        this.tabQnaQuestion === tabQna.TOP ||
        this.tabQnaQuestion === tabQna.NEW
      ) {
        if (item.answered || (!this.presentation.isModerationMode && item.status === 'dismissed')) return false
      }
      if (this.tabQnaQuestion === tabQna.ANSWERED) {
        if (!item.answered) return false
      }
      return true
    },
    changeTabQuestion(index) {
      this.$store.state.tabQnaQuestion = index
      const arr = JSON.parse(JSON.stringify(this.$store.state.questions))
      Utils.updateDataQuestionAnswer(arr, index)
      setTimeout(() => {
        document.getElementById('list-qna-question').scrollTo(0, 0)
      }, 200)
    },

    checkDisableSubmit() {
      if (
        !this.questionTitle.length ||
        this.questionTitle.length > 200 ||
        this.submiting
      ) { return true }
      return false
    },

    async submitQuestion() {
      storage.updateValueByPresentation(
        this.presentation.id,
        'audienceId',
        this.audienceId,
      )
      this.textError = ''
      const title = this.questionTitle.trim()
      let { questionerName } = this.$store.state
      if (questionerName) {
        questionerName = questionerName.trim()
      }
      if (!this.$store.state.presentation.qnaAnonymous && !questionerName) {
        this.textError = this.$t('enterYourNameWarning')
        return
      }
      if (
        this.$store.state.questionerName &&
        this.$store.state.questionerName.length > 20
      ) {
        this.textError = 'Your name is limited to 20 characters.'
        return
      }
      if (!title) {
        this.textError = this.$t('enterQuestionWarning')
        return
      }
      if (this.submiting) return
      this.submiting = true
      const payload = {
        audience: this.audienceId,
        audienceColor: this.audienceColor,
        presentationId: this.$store.state.presentation.id,
        title,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
      }
      if (this.$store.state.questionerName) {
        payload.audienceName = questionerName
      }
      try {
        this.$http.post(Config.api.createQuestion, payload)
        this.questionTitle = ''
        Utils.gaTrackEvent(
          'Question And Answer',
          'Audience',
          'Submitted question',
        )
        if (this.presentation.isModerationMode) {
          Utils.showToastSuccess('Your question is awaiting moderation')
        } else {
          Utils.showToastSuccess('Question sent')
        }
      } catch (error) {
        this.textError = 'Something went wrong, please try again.'
      } finally {
        this.submiting = false
        this.setUserTypingEnd()
      }
    },

    _getPlaceHolder() {
      if (this.$store.state.presentation.qnaAnonymous) {
        return this.$t('enterYourNameOptional')
      }
      return this.$t('yourNamePlaceholder')
    },

    getQuestionStatusIcon(question) {
      if (this.tabQnaQuestion === 4) {
        if (!question.status) {
          return 'pending'
        }
        if (question.status === 'dismissed') {
          return 'banned'
        }
      }
      return 'check'
    },

    onInput() {
      this.setUserTypingStart() // UserIsTypingMixin
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.upvote-wrapper {
  height: 17px;
}
.icon-pinned {
  position: absolute;
  right: 90px;
  opacity: 0.6;
}
.input-name {
  padding-left: 8px;
  margin-right: 8px;
  line-height: 40px;
  -webkit-appearance: none;

  &.error {
    color: $danger-color !important;
  }
}
.top-item-question {
  padding-right: 90px;
}
.text-error {
  text-align: center;
  font-size: 14px;
}
.question-count {
  position: absolute;
  right: 0;
  bottom: 18px;
  font-size: 14px;
  opacity: 0.8;
  top: 15px;

  .question-count-icon .fas {
    font-size: 16px;
  }

  @media (max-width: 350px) {
    bottom: 9px;
  }
  .question-count-icon,
  question-count-number {
    color: $base-70;
  }
  &.dark {
    .question-count-icon,
    question-count-number {
      color: $white;
    }
  }
}
.qna-session {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 16px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  max-width: 600px;
  margin: 0 auto;
  z-index: 2;
  position: relative;
  padding-bottom: 0;
}
.list-item-question {
  overflow: hidden;
  overflow-y: scroll;
}

.qna-submit-box {
  border-radius: 4px;
  overflow: hidden;

  input {
    height: 40px;
    border: none;
    background-color: #fff;
    padding-right: 8px;
    min-width: 50px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .button-submit {
    width: 90px;
    font-size: 14px;
    text-transform: capitalize;
    padding: 0;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    border-radius: 20px;
    background-color: $brand-a100;

    i {
      font-size: 14px;
    }
    .loading-spinner {
      margin-left: 4.5px;
      width: 1.2em;
      height: 1.2em;
    }
  }
}

.list-item-question {
  border-radius: 4px;
  overflow: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: inset 0 15px 10px -10px rgba(0, 0, 0, 0.04);

  .item-question {
    border-bottom: 1px solid #00000017;
    position: relative;

    &:last-child {
      border-bottom: 0;
    }

    .name-audience {
      margin-bottom: 2px;
    }

    .time-post {
      opacity: 0.6;
      font-size: 13px;
    }

    &:last-child {
      margin-bottom: 0;
      border-bottom: 0;
    }

    p {
      margin: 0;
    }

    .content-question {
      padding: 16px;
      padding-top: 0;
      padding-left: 0;
      white-space: pre-line;
      word-break: break-word;
    }
  }
}

.tab-list-question {
  position: relative;
  overflow: hidden;
  bottom: -1px;
  border-bottom: 1px solid #00000017;
  &.white-text {
    .active {
      border-color: inherit;
      color: inherit;
    }
  }
  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      float: left;
      font-size: 14px;
      padding: 16px 10px 10px;
      border-bottom: 3px solid transparent;
      cursor: pointer;

      @media (max-width: 350px) {
        padding: 16px 3px 10px;
        font-size: 12px;
      }
      &.active {
        font-weight: bold;
        border-color: $primary-color;
        color: $primary-color;
      }
    }
  }
}

.action-vote {
  position: absolute;
  right: 0;
  top: 17px;
  padding: 5px 10px;
  border-radius: 18px;
  width: 44px;
  text-align: center;
  font-size: 12px;
  cursor: pointer;
  border: 1.2px solid #d3d7e1;
  &:hover {
    background-color: $primary-90;
  }
  .upvote-count {
    color: $base-80;
  }
  .loading-spinner {
    width: 1em;
    height: 1em;
    margin-left: 3px;
  }
  .upvote-wrapper {
    height: 12px;
    margin-bottom: 1px;
    .upvote-icon {
      color: $base-70;
    }
  }
  // dark
  &.dark,
  &:hover {
    .upvote-wrapper .upvote-icon,
    .upvote-count {
      color: #ffffff;
    }
  }
}
.question-status {
  position: absolute;
  right: 3.5rem;
  margin-bottom: 6px;
  color: $base-60;
  font-size: 16px;
  &__answered-icon {
    margin-bottom: -0.5rem;
    right: 3.3rem;
    width: 24px;
    height: 24px;
  }
}
.text-box {
  position: relative;

  textarea {
    width: 100%;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #ddd;
    -webkit-appearance: none;
    outline: none;
    padding-bottom: 20px;
  }
  .count-char {
    position: absolute;
    bottom: 8px;
    right: 8px;
    font-size: 14px;
    color: #666;
  }

  &.error {
    textarea {
      border-color: $danger-color;
      color: $danger-color;
    }

    .count-char {
      color: $danger-color;
    }
  }
}

.avatar {
  .default-ava,
  .color-ava {
    background-color: $primary-color;
    width: 32px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    border-radius: 50%;
    margin: 16px;
    border: 1px solid #fff;
    margin-right: 8px;
    margin-left: 0;

    i {
      color: #fff;
    }
  }

  .color-ava {
    color: #fff;
    text-transform: uppercase;
    font-size: 13px;
    font-weight: bold;
  }
}

.no-allow-vote-count {
  .icon-pinned {
    right: 20px;
  }
}

.qna-session {
  &.text-white {
    .tab-list-question,
    .item-question {
      border-color: rgba(255, 255, 255, 0.2);
    }
  }
}

.close-icon {
  position: absolute;
  top: -28px;
  right: 0px;
  cursor: pointer;
  padding: 6px 10px 5px;
  z-index: 100;
  color: #fff;
  background-color: #000;
  border-radius: 25px;
  font-size: 10px;
  text-transform: uppercase;
}
</style>
